import styled from 'styled-components';

export const FilterContainer = styled.div`
  position: relative;
`;

export const SearchContainer = styled.div`
  display: flex;
`;
